// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   1. 공통 레이아웃 및 섹션 간격
========================================================= */
.gd-inner {
  width: 1200px;
  margin: 0 auto;
}

.gd-hero, .gd-phil, .gd-core, .gd-process, .safety-intro {
  padding: 40px 0;
}

@media (max-width: 1024px) {
  .gd-inner {
    width: 90%;
  }
}

/* =========================================================
   2. HERO & PHILOSOPHY (레이아웃)
========================================================= */
.gd-hero-wrap, .gd-phil-wrap {
  display: flex;
  align-items: center;
  gap: 80px;
}

.gd-hero-text, .gd-hero-img, .gd-phil-img, .gd-phil-text {
  width: 50%;
}

.gd-title {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #111;
}

.gd-badge {
  display: inline-block;
  background: #e5edff;
  color: #1e40af;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 20px;
}

.gd-sub {
  font-size: 20px;
  margin-bottom: 20px;
}

.gd-desc {
  font-size: 18px;
  font-weight: 500;
}

.gd-hero-img img, .gd-phil-img img, .safety-img img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* =========================================================
   3. CORE & PROCESS
========================================================= */
.gd-head, .process-head {
  text-align: center;
  margin-bottom: 40px;
}

.gd-process {
  background: linear-gradient(135deg, #0b1c4d, #001b8b);
  color: #fff;
}

.gd-process-box {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.gd-step {
  width: 18%;
  text-align: center;
}

.gd-num {
  font-size: 26px;
  font-weight: 700;
  color: #ff7a00;
  margin-bottom: 15px;
}

.gd-step ul {
  list-style: none;
  padding: 0;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
}

/* =========================================================
   4. SAFETY INTRO & MONITORING
========================================================= */
.safety-intro {
  padding: 80px 20px;
  max-width: 1200px;
  margin: auto;
}

.intro-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.intro-title img { height: 60px; }
.intro-title span { font-size: 32px; font-weight: 700; }

.feature-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px;
  margin-top: 60px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 24px;
}

.circle-icon {
  width: 80px;
  height: 80px;
  background: #000;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
}

.feature-item:hover .circle-icon {
  background: #001B8B;
  transform: scale(1.1);
}

.circle-icon svg { width: 56px; height: 56px; }

.monitor-highlight {
  margin: 70px 0;
  text-align: center;
}

.monitor-highlight p {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.5;
  color: #111;
}

.safety-img {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.safety-img img {
  height: 300px;
  object-fit: cover;
}

/* =========================================================
   5. 반응형 (통합)
========================================================= */
@media (max-width: 1024px) {
  .gd-hero-wrap, .gd-phil-wrap, .gd-process-box {
    flex-direction: column;
  }

  .gd-hero-text, .gd-hero-img, .gd-phil-img, .gd-phil-text, .gd-step {
    width: 100%;
    margin-bottom: 30px;
  }

  .feature-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./static/css/safety.css"],"names":[],"mappings":"AAAA;;2DAE2D;AAC3D;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;2DAE2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;2DAE2D;AAC3D;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;2DAE2D;AAC3D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB,YAAY,EAAE;AACjC,oBAAoB,eAAe,EAAE,gBAAgB,EAAE;;AAEvD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;2DAE2D;AAC3D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* =========================================================\n   1. 공통 레이아웃 및 섹션 간격\n========================================================= */\n.gd-inner {\n  width: 1200px;\n  margin: 0 auto;\n}\n\n.gd-hero, .gd-phil, .gd-core, .gd-process, .safety-intro {\n  padding: 40px 0;\n}\n\n@media (max-width: 1024px) {\n  .gd-inner {\n    width: 90%;\n  }\n}\n\n/* =========================================================\n   2. HERO & PHILOSOPHY (레이아웃)\n========================================================= */\n.gd-hero-wrap, .gd-phil-wrap {\n  display: flex;\n  align-items: center;\n  gap: 80px;\n}\n\n.gd-hero-text, .gd-hero-img, .gd-phil-img, .gd-phil-text {\n  width: 50%;\n}\n\n.gd-title {\n  font-size: 42px;\n  font-weight: 700;\n  margin-bottom: 25px;\n  color: #111;\n}\n\n.gd-badge {\n  display: inline-block;\n  background: #e5edff;\n  color: #1e40af;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.gd-sub {\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n\n.gd-desc {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.gd-hero-img img, .gd-phil-img img, .safety-img img {\n  width: 100%;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n/* =========================================================\n   3. CORE & PROCESS\n========================================================= */\n.gd-head, .process-head {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.gd-process {\n  background: linear-gradient(135deg, #0b1c4d, #001b8b);\n  color: #fff;\n}\n\n.gd-process-box {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 40px;\n}\n\n.gd-step {\n  width: 18%;\n  text-align: center;\n}\n\n.gd-num {\n  font-size: 26px;\n  font-weight: 700;\n  color: #ff7a00;\n  margin-bottom: 15px;\n}\n\n.gd-step ul {\n  list-style: none;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* =========================================================\n   4. SAFETY INTRO & MONITORING\n========================================================= */\n.safety-intro {\n  padding: 80px 20px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.intro-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.intro-title img { height: 60px; }\n.intro-title span { font-size: 32px; font-weight: 700; }\n\n.feature-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 60px;\n  margin-top: 60px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.circle-icon {\n  width: 80px;\n  height: 80px;\n  background: #000;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.3s;\n}\n\n.feature-item:hover .circle-icon {\n  background: #001B8B;\n  transform: scale(1.1);\n}\n\n.circle-icon svg { width: 56px; height: 56px; }\n\n.monitor-highlight {\n  margin: 70px 0;\n  text-align: center;\n}\n\n.monitor-highlight p {\n  font-size: 36px;\n  font-weight: 700;\n  line-height: 1.5;\n  color: #111;\n}\n\n.safety-img {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.safety-img img {\n  height: 300px;\n  object-fit: cover;\n}\n\n/* =========================================================\n   5. 반응형 (통합)\n========================================================= */\n@media (max-width: 1024px) {\n  .gd-hero-wrap, .gd-phil-wrap, .gd-process-box {\n    flex-direction: column;\n  }\n\n  .gd-hero-text, .gd-hero-img, .gd-phil-img, .gd-phil-text, .gd-step {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n\n  .feature-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
